import { Performer } from 'src/WebApiController';

import * as styles from './EventSearchDropdownResult.css';

export const PerformerSearchResultItem = ({
  performer,
}: {
  performer: Performer;
}) => {
  return (
    <div
      className={styles.eventSearchResultItemDiv}
      data-testid="event-search-dropdown-performer"
    >
      <div className={styles.eventSearchResultItemNameDiv}>
        {performer.name}
      </div>
    </div>
  );
};
